<script setup>
import {inject} from 'vue'
import TooltipComponent from '@/components/widgets/TooltipComponent.vue'
import {useRouter} from 'vue-router'
const router = useRouter()

const props = defineProps(['item'])
const contentData = inject('contentData')

/**
 * Input example: item = { link: 'sample-event', agenda_session: { name: 'Plenary' } }
 * Output example: navigates to /abstract/sample-event.
 */
const handleClick = (item, abstract = false, additional_info = false) => {
    if (item.link) {
        if (!abstract && !additional_info) {
            router.push(`/info/${item.link}`)
        } else if (additional_info && item.second_additional_info) {
            router.push(`/second-additional-info/${item.link}`)
        } else if (additional_info) {
            router.push(`/abstract/${item.link}`)
        } else {
            router.push(`/abstract/${item.link}`)
        }
    }
}

/**
 * Input example: item = { link: 'sample-event', second_additional_info: '<p>details</p>' }
 * Output example: navigates to /second-additional-info/sample-event.
 */
const handleSecondAdditionalInfoClick = item => {
    if (item.link && item.second_additional_info) {
        router.push(`/second-additional-info/${item.link}`)
    }
}
</script>

<template>
    <p :class="contentData.what === 'rn' && 'text-black'" class="inner">
        <!--        <TooltipComponent v-if="props.item.additional_info && contentData.what === 'rn'">-->
        <!--            <span class="text-blue-700 cursor-pointer uppercase">-->
        <!--                {{ props.item.title }}-->
        <!--            </span>-->
        <!--            <template v-slot:tooltip><p v-html="props.item.additional_info"></p></template>-->
        <!--        </TooltipComponent>-->

        <span
            class="uppercase"
            :class="
                props.item.link || props.item.general_link || props.item.agenda_session.name === 'Workshop'
                    ? 'cursor-pointer text-blue-600'
                    : ''
            "
            @click="handleClick(props.item, props.item.agenda_session.name !== 'Workshop')">
            {{ props.item.title }}
        </span>
    </p>
    <p class="text-blue-900" v-if="item.subtopic">{{ item.subtopic }}</p>
    <p
        v-if="contentData.what === 'rn' && !['Misc.', 'General'].includes(item.agenda_session.name)"
        :class="contentData.what === 'rn' && 'text-black'"
        class="italic">
        {{ item.agenda_session.name }}
    </p>
    <p :class="contentData.what === 'rn' && 'text-black'" class="font-bold" v-if="item.author">
        {{ props.item.author.join(', ') }}
    </p>

    <p
        class="text-black"
        v-if="contentData.what === 'rn' && item.agenda_session.name === 'Tutorials & Workshops'"
        v-html="item.topic"></p>

    <p
        :class="
            contentData.what === 'rn'
                ? 'text-black'
                : contentData.what === 'pht' && item.link
                  ? 'text-blue-600 cursor-pointer'
                  : ''
        "
        @click="handleClick(props.item, props.item.agenda_session.name !== 'Workshop')"
        class="italic text-ellipsis"
        v-if="item.topic && item.agenda_session.name !== 'Tutorials & Workshops'">
        {{ props.item.topic }}
    </p>

    <p
        v-if="item.second_additional_info_title && item.second_additional_info && item.link"
        class="mt-3 text-sm text-blue-700 cursor-pointer hover:text-blue-900 transition-colors italic text-ellipsis"
        @click="handleSecondAdditionalInfoClick(props.item)">
        {{ item.second_additional_info_title }}
    </p>
</template>

<style scoped>
.inner {
    max-width: 300px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}
</style>
